import { createGlobalStyle } from 'styled-components';

import MerriweatherBlack from '@/assets/fonts/merriweather-black.woff';
import Background from '@/assets/icons/cover-images/bpdaily-background.png';

const VariationStyles = createGlobalStyle`
  @font-face {
    font-family: 'MerriweatherBlack';
    src: url(${MerriweatherBlack});
    font-weight: 900;
    font-style: normal;
  }

  .generated-images-holder-var12 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1080px;
  }
  .image-holder-var12 {
    width: 100%;
    position: relative;
    height: 1350px;
    display: flex;
    flex-direction: column;
    padding: 49px 65px;
    background: url(${Background}) no-repeat center center;
    background-size: cover;
  }
 
  .bottom-text-var12 {
    height: 352px;
    position: absolute;
    left: 75px;
    bottom: 59px;
    width: calc(100% - 150px);
    font-size: 45px;
    line-height: 1.35;
    color: #fff;
    font-family: MerriweatherBlack;
    z-index: 1;
    display: flex;
    align-items: center;
    padding: 0 40px;
    background-color: rgba(0, 0, 0, 0.78);
    letter-spacing: 0.3px;
    p {
      display: inline-block;
      margin: 0;
      padding: 0;
      text-transform: uppercase;
    }
  }
  .image-wrap-var12 {
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
  }

  .full-image-var12 {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: relative;
    border: solid 10px #fff;
  }

  .circle-image-var12 {
   object-fit: cover;
    border-radius: 50%;
    border: solid 10px white;
    width: 450px;
    height: 450px;
    position: absolute;
    bottom: 373px;
    right: 30px;
    z-index: 2;
  }

  .breaking-news-var-11 {
    position: absolute;
    top: 90px;
    left: 0;
    right: 0;
    margin: auto;
  }

  .watermark-var12 {
    position: absolute;
    left: -86px;
    bottom: 110px;
    transform: rotate(-90deg);
  }
  .actual-photo-var12 {
    position: absolute;
    left: 10px;
    /* clears the text block: its top edge sits 362px up inside the photo */
    bottom: 372px;
    height: 72px;
  }
  .actual-photo-var12--top {
    top: 10px;
    bottom: auto;
  }
  /* the breaking news badge ends 131px down inside the photo */
  .actual-photo-var12--top.actual-photo-var12--breaking-news {
    top: 141px;
  }
`;

export default VariationStyles;
